import { ErrorBoundary } from '@sentry/react';
import { SideNav } from '../common/SideNav';
import { FallbackSideNav } from '../fallback/FallbackSideNav';
import { SinglePlatformSideNavFooterLinks } from './SinglePlatformSideNavFooterLinks';
import { SinglePlatformSideNavLinks } from './SinglePlatformSideNavLinks';

export const SinglePlatformSideNav = () => (
  <ErrorBoundary fallback={<FallbackSideNav />}>
    <SideNav
      SideNavMainComponent={SinglePlatformSideNavLinks}
      SideNavFooterComponent={SinglePlatformSideNavFooterLinks}
    />
  </ErrorBoundary>
);
